export default function toTwoDecimals(cost) {
  if (cost !== 0 && !cost) return undefined;

  return Number(cost).toFixed(2);
}
